/*!
* @alife/cn-uni-api v2.10.0
* (c) Alibaba Group Holding Limited.
*
* @license ISC
* @build at 2023/8/21 10:19:44
*/
import { WVCall } from '../../../bridges/windvane/index.js';
import '../../../bridge-adpter-api-0316c034.js';
import '../../../tslib.es6-e01eabb2.js';

function setNavigationBarTitle(params) {
    var _a;
    if (document) {
        document.title = (_a = params === null || params === void 0 ? void 0 : params.title) !== null && _a !== void 0 ? _a : '';
    }
    // https://page.cainiao.com/cn-yz/cnyz-book/_book/api/titlrbar.html?spm=a2d5h.23431112.0.0
    WVCall('TitlebarModule.setTitle', params, {
        formatInput: function (options) { return ({
            text: options === null || options === void 0 ? void 0 : options.title,
        }); },
    });
}

export { setNavigationBarTitle as default };
